import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/retry';

import { KeywordResponse, 
         ConfigService } from '../internal';

const RETRIES: number = 1;

@Injectable()
export class ApiService {
    private URI: string;
    
    constructor(private http: Http, private config: ConfigService) {
        // default to "{root}/api" if unspecified
        this.URI = this.config.get('api.url') || '/api';
    }
    
    requestCustomQueries(): Observable<any> {
        return this.http
            .get(`${this.URI}/CustomQuery`)
            .retry(RETRIES)
            .catch(this.catchHttpError)
            .map(this.parseResponseBody);
    }
    
    requestDocTypes(): Observable<any> {
        return this.http
            .get(`${this.URI}/DocumentType`)
            .retry(RETRIES)
            .catch(this.catchHttpError)
            .map(this.parseResponseBody);
    }
    
    requestKeywords(params: GetKeywordsParams): Observable<any> {        
        let body = JSON.stringify(params);
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        
        return this.http
            .post(`${this.URI}/Keywords`, body, options)
            .retry(RETRIES)
            .catch(this.catchHttpError)
            .map(this.parseResponseBody);
    }
    
    requestDocumentsByKeyword(params: GetDocumentsByKeywordParams): Observable<any> {        
        let body = JSON.stringify(params);
        let headers = new Headers({ 'Content-Type': 'application/json'});
        let options = new RequestOptions({ headers: headers });
        
        return this.http
            .post(`${this.URI}/CustomQuery/KeywordSearch`, body, options)
            .retry(RETRIES)
            .catch(this.catchHttpError)
            .map(this.parseResponseBody);
    }
    
    requestDocumentsByFullText(params: GetDocumentsByFullTextParams): Observable<any> {
        let body = JSON.stringify(params);
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        return this.http
            .post(`${this.URI}/DocumentType/FullTextSearch`, body, options)
            .retry(RETRIES)
            .catch(this.catchHttpError)
            .map(this.parseResponseBody);
    }

    getDocumentUri(docID: string): string {
        // trailing forward slash hides docID from Chrome's PDF viewer
        let fullUri = `${this.URI}/Document/${encodeURIComponent(docID)}/`;
        return fullUri;
    }

    tryDocumentUri(docID: string): Observable<any> {
        let body = "{}";
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });

        return this.http
            .post(this.getDocumentUri(docID), body, options)
            .retry(RETRIES)
            .catch(this.catchHttpError)
            .map(this.parseResponseBody);
    }

    private parseResponseBody(res: Response): any {
        return res.json() || {};
    }
    
    private catchHttpError(error: any) {
        let errorMessage: string;
        if (error.message) {
            errorMessage = `ApiService HTTP error: ${error.message}`;
        } else if (error.status) {
            errorMessage = `ApiService HTTP error: ${error.status} - ${error.statusText}`;
        } else {
            errorMessage = "ApiService HTTP error."
        }
        
        console.log(errorMessage);
        return Observable.throw(errorMessage);
    }
}

export interface GetKeywordsParams {
    QueryID?: number;
    DocTypeID?: number;
}

export interface GetDocumentsByKeywordParams {
    QueryID?: number;
    Keywords?: KeywordResponse[];
    FromDate?: Date;
    ToDate?: Date;
    FolderID?: string;
    QueryLimit?: number;
}

export interface GetDocumentsByFullTextParams {
    SearchText?: string;
    FromDate?: Date;
    ToDate?: Date;
    QueryID?: number;
    DocTypeID?: number;
    Keywords?: KeywordResponse[];
    QueryLimit?: number;
}



// WEBPACK FOOTER //
// ./src/app/shared/services/api.service.ts